import '../styles/Splash.css';
import logo from '../assets/logo.png';

function LogoSplash({ show }) {
    return (
        <div className={`logo-splash ${show ? 'visible' : 'hidden'}`} aria-hidden={!show}>
            <div className="logo-splash-glow" />
            <div className="logo-splash-card">
                <img src={logo} alt="Riktigt Rent" />
                <p>Vi laddar rent och klart...</p>
                <div className="logo-splash-bar" aria-hidden="true">
                    <span />
                </div>
            </div>
        </div>
    );
}

export default LogoSplash;
